import script from "./chatTextarea.vue?vue&type=script&setup=true&lang=ts"
export * from "./chatTextarea.vue?vue&type=script&setup=true&lang=ts"

import "./chatTextarea.vue?vue&type=style&index=0&id=2483d8d2&scoped=true&lang=css"

import exportComponent from "/Users/berkuralcan/Documents/dev/webdev/dansuk-engineering-dashboard-v3/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2483d8d2"]])

export default __exports__